<template>
  <div class="exclude-amount-box">
    <el-popover
      ref="popover"
      v-model="visible"
      placement="bottom-start"
      width="250"
      trigger="click"
      popper-class="exclude-amount-popper"
      :append-to-body="false"
    >
      <div slot="reference">
        <div class="trigger-box" :class="{ 'is-active': visible }">
          <span class="trigger-text">{{ maintext || placeholder }}</span>
        </div>
        <span> 的订单</span>
      </div>
      <div class="popover-content" v-loading="loading">
        <div class="popover-item">
          小于
          <div class="excluInput">
            <el-input
              style="width: 86px"
              v-model="form[fieldKeys[0]]"
              @input="form[fieldKeys[0]] = handleInput2($event, 2, 0)"
              placeholder="请输入"
            ></el-input>
            <span class="unit">元</span>
          </div>
        </div>
        <div class="popover-item">
          大于
          <div class="excluInput">
            <el-input
              style="width: 86px"
              v-model="form[fieldKeys[1]]"
              @input="form[fieldKeys[1]] = handleInput2($event, 2, 0)"
              placeholder="请输入"
            ></el-input>
            <span class="unit">元</span>
          </div>
        </div>
        <div class="popover-item">
          介于
          <div class="excluInput">
            <el-input
              style="width: 86px"
              v-model="form[fieldKeys[2]]"
              @input="form[fieldKeys[2]] = handleInput2($event, 2, 0)"
              placeholder="请输入"
            ></el-input>
            <span class="unit">元</span>
          </div>
          至
          <div class="excluInput">
            <el-input
              style="width: 86px"
              v-model="form[fieldKeys[3]]"
              @input="form[fieldKeys[3]] = handleInput2($event, 2, 0)"
              placeholder="请输入"
            ></el-input>
            <span class="unit">元</span>
          </div>
        </div>
        <div class="popover-bottom">
          <el-checkbox v-if="isShowGlobal" v-model="checked"
            ><span class="checkText">应用于全局</span></el-checkbox
          >
          <div v-else></div>
          <div class="btnBox">
            <span class="btn sureBtn" @click="handleSure">确定</span>
            <span class="btn calcelBtn" @click="close">取消</span>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  querySectionConfig,
  saveSectionConfig,
} from "@/api/bi/reviewReport/sectionConfig.js";

import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "ExcludeAmountCom",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    fieldKeys: {
      type: Array,
      default: () => [
        "excludeOrderAmount",
        "excludeGreaterThanOrderAmount",
        "excludeOrderAmountStart",
        "excludeOrderAmountEnd",
      ],
    },
    initFormData: {
      type: Boolean,
      default: false,
    },
    isFormInit: {
      type: Boolean,
      default: true,
    },
    isShowGlobal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const form = {};
    this.fieldKeys.forEach((key) => {
      form[key] = "";
    });
    return {
      visible: false,
      checked: true,
      originalChecked: true,
      maintext: "",
      loading: false,
      form,
      originalForm: null, // 原始数据(用于重置)
      currentForm: null, // 当前数据(仅在当前页面使用)
    };
  },
  async mounted() {
    // 初始化时查询配置
    if(!this.isFormInit) {
      await this.querySectionConfigFn();
      this.$emit("initExclude", "exclude");
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!isEqual(newVal, this.form)) {
          this.form = cloneDeep(newVal || {});
        }
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        this.$emit("input", cloneDeep(newVal));
        this.updateMainText();
      },
      deep: true,
    },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          const popover = this.$refs.popover;
          if (popover && popover.$refs.popper) {
            popover.$refs.popper.removeAttribute("aria-hidden");
          }
          this.querySectionConfigFn();
        });
      }
    },
    initFormData: {
      async handler(val) {
        if(val) {
          await this.querySectionConfigFn();
          this.$emit("initExclude", "exclude");
        }
      },
      immediate: true
    },
  },
  methods: {
    checkExculd() {
      const [k0, k1, k2, k3] = this.fieldKeys;
      const excludeOrderAmount = this.form[k0];
      const excludeGreaterThanOrderAmount = this.form[k1];
      const excludeOrderAmountStart = this.form[k2];
      const excludeOrderAmountEnd = this.form[k3];

      if (excludeOrderAmount && excludeGreaterThanOrderAmount) {
        if (Number(excludeOrderAmount) == 0 || Number(excludeGreaterThanOrderAmount) == 0) {
          this.$message.warning("排除订单金额需要大于 0");
          return false;
        }
        if (
          Number(excludeOrderAmount) >= Number(excludeGreaterThanOrderAmount)
        ) {
          this.$message.warning(
            "排除订单金额小于的值需小于排除订单金额大于的值",
          );
          return false;
        }
      }
      if (excludeOrderAmountStart && excludeOrderAmountEnd) {
        if (Number(excludeOrderAmountStart) > Number(excludeOrderAmountEnd)) {
          this.$message.warning("介于开始金额需小于等于介于结束金额");
          return false;
        }
      }
      if (
        (!excludeOrderAmountStart && excludeOrderAmountEnd) ||
        (excludeOrderAmountStart && !excludeOrderAmountEnd)
      ) {
        this.$message.warning("介于不能只填写一个值");
        return false;
      }
      return true;
    },
    setFormValues(source = {}, isChecked = true, keys = this.fieldKeys) {
      this.fieldKeys.forEach((key, index) => {
        this.$set(this.form, key, source[keys[index]] || "");
      });
      if (isChecked) {
        this.checked = this.fieldKeys.some((key) => !!this.form[key]);
        this.originalChecked = this.checked;
      }
      this.updateMainText();
    },
    async querySectionConfigFn() {
      if (!this.checked) return;
      this.loading = true;
      try {
        const res = await querySectionConfig({ type: 20 });
        if (res.code === 200 || res.code == 1) {
          const data = res.data ? JSON.parse(res.data) : null;
          if (data && Object.keys(data).length > 0) {
            if(!this.isFormInit || this.form.firstForm){
              this.originalForm = cloneDeep(data);
              this.currentForm = cloneDeep(data);
              this.setFormValues(data, true, [
                "excludeOrderAmount",
                "excludeGreaterThanOrderAmount",
                "excludeOrderAmountStart",
                "excludeOrderAmountEnd",
              ]);
              this.$set(this.form, "firstForm", false);
              if(this.isFormInit){
                this.originalForm = []
                this.checked = false;
                this.originalChecked = false;
              }
            }else{
              this.checked = false;
              this.originalChecked = false;
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    updateMainText() {
      const [k0, k1, k2, k3] = this.fieldKeys;
      const excludeOrderAmount = this.form[k0];
      const excludeGreaterThanOrderAmount = this.form[k1];
      const excludeOrderAmountStart = this.form[k2];
      const excludeOrderAmountEnd = this.form[k3];

      let textArr = [];
      if (excludeOrderAmount) {
        textArr.push(`小于${excludeOrderAmount}元`);
      }
      if (excludeGreaterThanOrderAmount) {
        textArr.push(`大于${excludeGreaterThanOrderAmount}元`);
      }
      if (excludeOrderAmountStart && excludeOrderAmountEnd) {
        textArr.push(
          `介于${excludeOrderAmountStart}元至${excludeOrderAmountEnd}元`,
        );
      }
      this.maintext = textArr.join("，");
    },
    async reset() {
      console.warn("--- ~ this.originalForm:--12-", this.originalForm)
      if (this.originalForm) {
        this.setFormValues(this.originalForm, true, [
          "excludeOrderAmount",
          "excludeGreaterThanOrderAmount",
          "excludeOrderAmountStart",
          "excludeOrderAmountEnd",
        ]);
      } else {
        this.setFormValues(this.originalForm || {}, false, [
        "excludeOrderAmount",
        "excludeGreaterThanOrderAmount",
        "excludeOrderAmountStart",
        "excludeOrderAmountEnd",
      ]);
        this.checked = true;
        this.originalChecked = this.checked;
      }
      await this.querySectionConfigFn();
    },
    async handleSure() {
      if (!this.checkExculd()) return;
      const payloadData = {};
      let ksys = [
        "excludeOrderAmount",
        "excludeGreaterThanOrderAmount",
        "excludeOrderAmountStart",
        "excludeOrderAmountEnd",
      ];
      this.fieldKeys.forEach((key, index) => {
        payloadData[ksys[index]] = this.form[key];
      });

      this.$emit("saveExclude");
      this.originalChecked = this.checked;
      if (!this.checked) {
        this.updateMainText();
        this.visible = false;
        this.currentForm = cloneDeep(payloadData);
        return;
      }
      this.loading = true;

      const params = {
        type: 20,
        data: JSON.stringify(payloadData),
      };
      try {
        const res = await saveSectionConfig(params);
        if (res.code === 200 || res.code == 1) {
          this.originalForm = cloneDeep(payloadData);
          this.$message.success("保存成功");
          this.updateMainText();
          this.visible = false;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.visible = false;
      this.checked = this.originalChecked;
      this.setFormValues(this.currentForm || {}, false, [
        "excludeOrderAmount",
        "excludeGreaterThanOrderAmount",
        "excludeOrderAmountStart",
        "excludeOrderAmountEnd",
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
.exclude-amount-box {
  width: 300px;
  .trigger-box {
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 250px;
    background: #fff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdee1;

    &:hover,
    &.is-active {
      border-color: #3159ff;
    }
    .trigger-text {
      font-size: 14px;
      color: #333;
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .suffix-icon {
      color: #c0c4cc;
    }
  }
  .popover-content {
    .popover-item {
      margin-bottom: 12px;
      text-wrap: nowrap;
      padding: 0 12px;
      .excluInput {
        position: relative;
        display: inline-flex;
        :deep(.el-input__inner) {
          padding-right: 25px !important;
        }
        .unit {
          position: absolute;
          top: 50%;
          right: 20px;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
        }
      }
    }
    .popover-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #666666;
      padding: 8px 8px 6px 12px;
      border-top: 1px solid #f5f5f7;
      margin-top: 12px;
      .checkText {
        color: #666666;
        font-size: 12px;
      }
      .btnBox {
        display: flex;
        gap: 4px;
        .btn {
          width: 42px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          &.sureBtn {
            background: #3159ff;
            color: #fff;
          }
          &.calcelBtn {
            background: #ffffff;
            border: 1px solid #dcdfe6;
          }
        }
      }
    }
  }
  :deep(.el-popover) {
    padding: 12px 0px 0;
  }
}
</style>
